module.exports = __webpack_public_path__ + "static/media/faisal.d58f41ef.jpeg";